"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextPaneFooterSep = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const context_1 = require("../../styles/context");
/**
 * Mirror of {@link ContextPaneHeaderSep} for the bottom edge of a pane.
 */
const ContextPaneFooterSep = () => {
    const styles = (0, context_1.useStyles)();
    return (React.createElement("div", { style: { background: styles.g(0, 0.05), width: '100%', height: 8, marginTop: -8 } },
        React.createElement("div", { style: {
                background: styles.light ? styles.bg + '' : styles.g(0.94),
                borderRadius: '0 0 8px 8px',
                width: '100%',
                height: '8px',
            } })));
};
exports.ContextPaneFooterSep = ContextPaneFooterSep;
